module.exports = __webpack_public_path__ + "media/promo/hochland/images/menu_m-06138ea72e9414ff837678739f7447ee.png";